import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";

export default function OccupiedLocationModal({
  open,
  onClose,
  onKeepCurrentLocation,
  onMoveToNewLocation,
  locationName,
}) {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{ position: "absolute", right: 8, top: 8, zIndex: 1 }}
      >
        <CloseIcon />
      </IconButton>
      <DialogTitle>
        <Typography fontSize={24} fontWeight={400} align="center" color="text.primary">
          Attention
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" py={2} textAlign="center">
          <Typography color="text.primary">
            This mobile location is currently assigned to {locationName}.
          </Typography>
          <Typography color="text.primary">
            Do you want to keep it there, or move it to a new location?
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 2, justifyContent: "center", gap: 2 }}>
        <Button onClick={onMoveToNewLocation} variant="outlined" color="primary" size="large">
          Move to New Location
        </Button>
        <Button onClick={onKeepCurrentLocation} variant="contained" color="primary" size="large">
          Keep Current Location
        </Button>
      </DialogActions>
    </Dialog>
  );
}
